import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileCardZoom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.176 5.765v.706a.36.36 0 0 1-.352.353h-2v2a.36.36 0 0 1-.353.352h-.706a.34.34 0 0 1-.353-.352v-2h-2a.34.34 0 0 1-.353-.353v-.706a.36.36 0 0 1 .353-.353h2v-2a.36.36 0 0 1 .353-.353h.706a.38.38 0 0 1 .353.353v2h2a.38.38 0 0 1 .352.353m5.765 8.53-.677.675c-.117.147-.352.147-.5 0l-3.558-3.558a.47.47 0 0 1-.088-.265v-.382a6.2 6.2 0 0 1-4 1.47A6.114 6.114 0 0 1 0 6.118C0 2.765 2.735 0 6.118 0c3.353 0 6.117 2.765 6.117 6.118a6.16 6.16 0 0 1-1.5 4h.382c.089 0 .177.059.266.117l3.558 3.559c.147.147.147.383 0 .5m-4.118-8.177a4.72 4.72 0 0 0-4.705-4.706 4.7 4.7 0 0 0-4.706 4.706 4.68 4.68 0 0 0 4.706 4.705 4.7 4.7 0 0 0 4.705-4.705"
    />
  </svg>
);
export default SvgFileCardZoom;
